import { CardData } from './card-data';

export class DougCardData extends CardData {}
